<template>
    <div class="login">
        <div class="login-content">
            <div class="logo">
                <img src="/static/img/logo.png" alt="logo"/>
                <!-- <h1 v-if="clientId == 1">管理员后台</h1>
                <h1 v-else-if="clientId == 2">客户登录</h1>
                <h1 v-else-if="clientId == 3">客户登录</h1> -->
                <h1>路易投资信息化管理系统</h1>
            </div>

            <Form ref="formInline" :model="formInline" :rules="ruleInline">
                <FormItem prop="account">
                    <Input type="text" v-model="formInline.account" placeholder="用户名" size="large" @on-enter="handleSubmit('formInline')">
                        <Icon type="ios-person-outline" slot="prepend"></Icon>
                    </Input>
                </FormItem>
                <FormItem prop="password">
                    <Input type="password" v-model="formInline.password" placeholder="密 码" size="large" @on-enter="handleSubmit('formInline')">
                        <Icon type="ios-key-outline" slot="prepend"></Icon>
                    </Input>
                </FormItem>
                <!-- <FormItem prop="captcha">
                    <Row>
                        <Col span="8">
                            <Input type="text" v-model="formInline.captcha" placeholder="验证码" size="large" @on-enter="handleSubmit('formInline')">
                                <Icon type="ios-lock-outline" slot="prepend"></Icon>
                            </Input>
                        </Col>
                        <Col class="loginCode" span="16">  
                            <img :src="codeUrl" alt="">
                            <Button type="text" icon="md-refresh" @click="getCode">换一张</Button>
                        </Col>
                    </Row>
                </FormItem> -->
                <FormItem>
                    <Button type="primary" long @click="handleSubmit('formInline')" size="large" :loading="isLoading">
                        登 录 <Icon type="ios-arrow-dropright" />
                    </Button>
                </FormItem>
            </Form>
        </div>
        <div class="copyright" v-if="clientId == 1">
            copyright&copy;2020    路易师傅版权所有，保留权利
        </div>
    </div>
</template>
<script>
    import {mapGetters, mapActions} from 'Vuex'
    import axios from 'axios'
    export default {
         data () {
            return {
                isLoading: false,
                formInline: {
                    account: '',
                    password: '',
                    // captcha: '',
                    scope: '*',
                    grant_type: 'password',
                    client_id: 3,
                    client_secret: 'CAMIGZh7K4wFCmGEYYzrPNneOR7pzTY2QUoADeYD'
                },
                ruleInline: {
                    account: [
                        { required: true, message: '请输入用户名', trigger: 'blur' }
                    ],
                    password: [
                        { required: true, message: '请输入密码', trigger: 'blur' },
                        { type: 'string', min: 6, message: '密码不少于6位', trigger: 'blur' }
                    ],
                    // captcha: [
                    //     { required: true, message: '请输入验证码', trigger: 'blur' }
                    // ]
                },
                codeUrl: '' // 验证码的图片
            }
        },
        computed: {
            ...mapGetters(['clientId', 'env', 'clientConfig', 'logo', 'background']),
            /**
             * 根据对应的clientId返回client名称
             */
            clientName () {
                let str = ''
                return str
            }
        },
        mounted () {
            let client = this.clientConfig[this.env][this.clientId - 1]
            Object.assign(this.formInline, client)
            // this.getCode()
        },
        methods: {
            ...mapActions([
                'updateTokon',
                'updateHlfTokon',
                'updateAuthorizd'
            ]),
            handleSubmit(name) {
                this.isLoading = true
                this.$refs[name].validate((valid) => {
                    if (valid) {
                        axios.post('/pc/login', this.formInline).then((rs) => {
                            this.isLoading = false
                            if (rs.data.status == 401) {
                                this.$Message.error({content: rs.data.msg, duration: 5 })
                                // 这里登录失败了，重新请求验证吗
                            //  this.getCode()
                            } else if (rs.data.status == 500) {
                                this.$Message.error({content: rs.data.msg, duration: 5 })
                            } else if (rs.data.status == 404) {
                                this.$Message.error({content: rs.data.msg, duration: 5 })
                            }else {
                                let token = rs.data.data.token_type + ' ' + rs.data.data.access_token
                                let hlftokon = rs.data.data.access_token_91
                                // 1、将tokon存放到vuex中
                                this.updateTokon(token)
                                // this.updateHlfTokon(hlftokon)
                                // 2、本地存储tokon
                                this.$path.saveTokon(token)
                                // this.$path.saveHlfTokon(hlftokon)
                                // 3、改变authorizd状态
                                this.updateAuthorizd(true)
                                // 4、路由跳转到默认页面
                                this.$Message.success('登录成功')
                            }
                        }).catch((err) => {
                            this.isLoading = false
                            this.$Message.error({content: err, duration: 5 })
                        })
                    } else {
                        this.$Message.error('请将登录信息输入完整!');
                        this.isLoading = false
                    }
                })
            },
            /**
             * 获得验证码
             */
            getCode () {
                if (this.timer) clearTimeout(this.timer)
                this.timer = setTimeout(() => {
                    this.$api.query(this.clientName + '/code').then((rs) => {
                        this.codeUrl = rs.url
                    })
                }, 500) 
            }
        }
    }
</script>
<style>
.login {
    position: relative;
    height: 100%;
    background-position: center 0;
    background-repeat: no-repeat;
    background-image: url('../../static/img/banner.png');
    display: flex;
    justify-content: center;
    align-items: center;
        z-index: 1;
}
.login::after {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    content: " ";
    background: hsla(0, 0%, 0%, .25);
    -webkit-backdrop-filter: blur(20px);    
    backdrop-filter: blur(20px);    
    z-index: 2;
}
.login-content {
    position: absolute;
    width: 430px;
    padding: 0 30px 20px 30px;
    background: hsla(0, 0%, 100%, .2);
    border: 1px solid hsla(0, 0%, 100%, .05);
    border-radius: 4px;
    z-index: 3;
}
.login-content .logo {
    text-align: center;
    margin-bottom: 25px;
    padding-top: 30px;
}
.login-content .logo img{
    /* width: 200px; */
    height: 80px;
}
.logo h1 {
    color: #fff;
    font-size: 26px;
    margin-top: 20px;
}
.loginCode  {
    text-align: right;
}
.loginCode img{
    width: 120px;
    height: 35px;
    vertical-align: middle;
}
.copyright {
    position: fixed;
    left: 0;
    bottom: 20px;
    width: 100%;
    color: rgba(255, 255, 255, .6);
    text-align: center;
}
</style>


// WEBPACK FOOTER //
// src/views/login.vue